import { Percent } from '@uniswap/sdk-core';
import { Pair } from '@uniswap/v2-sdk';
import { Pool } from '@uniswap/v3-sdk';
import _ from 'lodash';
import { CurrencyAmount } from '.';
export var routeToString = function routeToString(route) {
  var isV3Route = function isV3Route(route) {
    return route.pools != undefined;
  };

  var routeStr = [];
  var tokens = isV3Route(route) ? route.tokenPath : route.path;

  var tokenPath = _.map(tokens, function (token) {
    return "".concat(token.symbol);
  });

  var pools = isV3Route(route) ? route.pools : route.pairs;

  var poolFeePath = _.map(pools, function (pool) {
    return "".concat(pool instanceof Pool ? " -- ".concat(pool.fee / 10000, "% [").concat(Pool.getAddress(pool.token0, pool.token1, pool.fee), "]") : " -- [".concat(Pair.getAddress(pool.token0, pool.token1), "]"), " --> ");
  });

  for (var i = 0; i < tokenPath.length; i++) {
    routeStr.push(tokenPath[i]);

    if (i < poolFeePath.length) {
      routeStr.push(poolFeePath[i]);
    }
  }

  return routeStr.join('');
};
export var routeAmountsToString = function routeAmountsToString(routeAmounts) {
  var total = _.reduce(routeAmounts, function (total, cur) {
    return total.add(cur.amount);
  }, CurrencyAmount.fromRawAmount(routeAmounts[0].amount.currency, 0));

  var routeStrings = _.map(routeAmounts, function (_ref) {
    var protocol = _ref.protocol,
        route = _ref.route,
        amount = _ref.amount;
    var portion = amount.divide(total);
    var percent = new Percent(portion.numerator, portion.denominator);
    return "[".concat(protocol, "] ").concat(percent.toFixed(2), "% = ").concat(routeToString(route));
  });

  return _.join(routeStrings, ', ');
};
export var routeAmountToString = function routeAmountToString(routeAmount) {
  var route = routeAmount.route,
      amount = routeAmount.amount;
  return "".concat(amount.toExact(), " = ").concat(routeToString(route));
};
export var poolToString = function poolToString(p) {
  return "".concat(p.token0.symbol, "/").concat(p.token1.symbol).concat(p instanceof Pool ? "/".concat(p.fee / 10000, "%") : "");
};